import React from 'react';
import Slider from 'react-slick';

const AIEnabledFintech = () => {
    const testimonialsettings = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            AI-Enabled FinTech App Development Services
                        </h2>
                        <p className="text-textcolor mb-0 fw-600">
                            Enhance your digital transformation with AI-driven capabilities.
                        </p>
                    </div>
                </div>

                <div className="section pb-16 dark:bg-black case-study-slider-img aienabled-fintech-slider">
                    <div className="container-fluid lg:container-fluid mx-auto">
                        <Slider {...testimonialsettings} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border">
                                        <div className="bg-improving-efficiency bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Improving Efficiency with AI-Powered Financial Services
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                We build AI-first platforms that automate key banking workflows, reduce processing
                                                time, and improve service delivery across mobile banking apps, digital wallets,
                                                and payment systems.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border">
                                        <div className="bg-ai-enabled-customer bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                AI-Enabled Customer Engagement Apps
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Boost customer satisfaction and retention with intelligent engagement tools. Our
                                                fintech app development services include chatbots, recommendation engines, and
                                                personalized onboarding flows.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border">
                                        <div className="bg-navigating-complexity bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Navigating the Complexity of Financial Decision
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                We design decision-support systems powered by AI to simplify complex financial
                                                planning, lending risk assessments, and credit scoring — key components of modern
                                                financial software development services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border">
                                        <div className="bg-mobile-accounting bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Mobile Accounting Applications
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Our team develops smart accounting software and expense tracking apps for finance
                                                teams and end-users, integrated with predictive insights and automated
                                                reconciliation.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border">
                                        <div className="bg-risk-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Risk Management & Analysis
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Integrate advanced risk analytics into your custom fintech software development
                                                projects. Our tools proactively detect threats and ensure regulatory compliance
                                                through AI-driven insights.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border">
                                        <div className="bg-financial-planning bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Financial Planning Algorithms
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Help users make smarter investment and savings decisions. We design algorithms
                                                that support wealth management, retirement planning, and cash flow forecasting in
                                                real time.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border">
                                        <div className="bg-financial-analysis bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Financial Analysis Software
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                We create enterprise-grade analytics platforms that provide actionable insights
                                                for portfolio managers, CFOs, and fintech startups — with intuitive dashboards and
                                                automated reporting.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border">
                                        <div className="bg-cloud-based bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Cloud-Based FinTech Digital Solutions
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                As a full-scale fintech application development company, we build scalable,
                                                AI-ready cloud applications that support neobanking, payment processing, and
                                                global money transfer services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AIEnabledFintech;
